import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreStore } from '@web/core/store/core.store';
import { MainHeaderComponent } from './libs/main-header/main-header.component';
import { MainSidebarComponent } from './libs/main-sidebar/main-sidebar.component';

@Component({
  selector: 'app-main-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, MainSidebarComponent, MainHeaderComponent],
  template: ` @let _user = user();
    <div class="flex flex-col h-full w-full p-2.5 gap-2.5 bg-surface-50">
      <div class="px-2"><app-main-header [tenant]="tenant()" [user]="_user" /></div>
      <div class="flex flex-1 w-full overflow-hidden min-h-100 gap-3.5">
        <app-main-sidebar [buildInfo]="buildInfo()" />
        <main class="flex-1 border rounded-xl border-surface bg-white max-h-full overflow-hidden">
          <router-outlet />
        </main>
      </div>
    </div>`,
  styles: ``,
})
export class MainLayoutComponent {
  private readonly coreStore: CoreStore = inject(CoreStore);

  readonly user = this.coreStore.identity;
  readonly buildInfo = this.coreStore.buildInfo;
  readonly tenant = this.coreStore.tenant;

  constructor() {
    this.coreStore.getMe();
  }
}
